import { render } from "./theme42.vue?vue&type=template&id=1b539ff9&scoped=true"
import script from "./theme42.vue?vue&type=script&lang=js"
export * from "./theme42.vue?vue&type=script&lang=js"

import "./theme42.vue?vue&type=style&index=0&id=1b539ff9&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1b539ff9"

export default script